import { Component } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import Hr from 'UIComponents/elements/HR';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TimestampPreview extends Component {
  render() {
    const {
      timestamp,
      use
    } = this.props;
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlock: "200",
      children: [/*#__PURE__*/_jsx(Hr, {
        distance: "extra-small"
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `platformTest.details.${use}`,
          options: {
            datetime: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
              value: timestamp,
              format: "lll z"
            })
          }
        })
      })]
    });
  }
}
TimestampPreview.defaultProps = {
  use: 'deferred'
};
export default TimestampPreview;